const API_URL = 'https://consumos.talsa.com.co/api/talsa/proveedores';

export const listFiles = async (prefix = "") => {
    try {
        const response = await fetch(`${API_URL}/list`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prefix })
        });
        return await response.json();
    } catch (error) {
        console.error("Error listing files:", error);
        return { carpetas: [], archivos: [] };
    }
};

export const createFolder = async (path) => {
    try {
        const response = await fetch(`${API_URL}/create-folder`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ path })
        });
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const uploadFile = async (path, file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
            try {
                const base64 = reader.result.split(',')[1];
                const response = await fetch(`${API_URL}/upload`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        path,
                        name: file.name,
                        base64
                    })
                });
                const data = await response.json();
                resolve(data);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = error => reject(error);
    });
};

export const uploadBase64 = async (path, fileName, base64) => {
    try {
        const response = await fetch(`${API_URL}/upload`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                path,
                name: fileName,
                base64
            })
        });
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const moveFile = async (source, destination) => {
    try {
        const response = await fetch(`${API_URL}/move`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ source, destination })
        });
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const getFileUrl = async (path) => {
    try {
        const response = await fetch(`${API_URL}/get-url`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ path })
        });
        return await response.json();
    } catch (error) {
        throw error;
    }
};
